import React, { Component } from 'react';
import './App.css';
import Tone from 'tone';
import P5Wrapper from 'react-p5-wrapper';

const kik = new Tone.Player({
  "url": "kik.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 16.68,
  "volume": -Infinity
}).toMaster();

const snare = new Tone.Player({
  "url": "snare.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 16.68,
  "volume": -Infinity
}).toMaster();

const hihat = new Tone.Player({
  "url": "hihat.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 16.68,
  "volume": -Infinity
}).toMaster();

const bass = new Tone.Player({
  "url": "bass.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 16.68,
  "volume": -Infinity
}).toMaster();

const synth1 = new Tone.Player({
  "url": "synth1.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 16.68,
  "volume": -Infinity
}).toMaster();

const synth2 = new Tone.Player({
  "url": "synth2.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 16.68,
  "volume": -Infinity
}).toMaster();

const synth3 = new Tone.Player({
  "url": "synth3.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 16.68,
  "volume": -Infinity
}).toMaster();

const synth4 = new Tone.Player({
  "url": "synth4.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 16.68,
  "volume": -Infinity
}).toMaster();

const players = [kik, snare, hihat, bass, synth1, synth2, synth3, synth4];

class Mixer extends Component {

  constructor() {
    super();

    this.state = {
      phase0: true,
      phase1: false
    }

    this.begin = this.begin.bind(this);
  }

  componentDidMount() {
    console.log("13");
  }

  begin() {
    this.setState({
      phase0: false,
      phase1: true
    });
    for (var i = 0; i < players.length; i++) {
      players[i].start();
    };
  }

  render() {
    return (
      <div className="App">
        <div className="content">
          <div className={this.state.phase0 === true ? "begin" : "phase0-hide"}>
            <img className="begin-img" src="begin.png" alt="begin" onClick={() => {
              this.begin();
            }} />
          </div>
          <div className={this.state.phase1 === true ? "sketch" : "phase1-hide"}>
            <P5Wrapper sketch={sketch} />
          </div>
        </div>
      </div>
    );
  }
}

function sketch(p) {

  // sP = starting point; eP = ending point; kD = knob diameter
  var kD = 30;

  var sPX1, sPX2, sPX3, sPX4, sPX5, sPX6, sPX7, sPX8;
  var sPY1, sPY2, sPY3, sPY4, sPY5, sPY6, sPY7, sPY8;
  var sPXs = [sPX1, sPX2, sPX3, sPX4, sPX5, sPX6, sPX7, sPX8];
  var sPYs = [sPY1, sPY2, sPY3, sPY4, sPY5, sPY6, sPY7, sPY8];
  var lineSPXs = [];
  var lineSPYs = [];
  var lineEPXs = [];
  var lineEPYs = [];
  var knobColor = 150;
  var mute1, mute2, mute3, mute4, mute5, mute6, mute7, mute8;
  var muteKnobs = [mute1, mute2, mute3, mute4, mute5, mute6, mute7, mute8];

  for (var i = 0; i < 8; i++) {
    sPXs[i] = p.windowWidth / 2 - p.windowWidth / 4;
    sPYs[i] = (p.windowHeight / 10) * (i + 1);
    let lineSPX = p.windowWidth / 2 - p.windowWidth / 4;
    lineSPXs.push(lineSPX);
    let lineSPY = (p.windowHeight / 10) * (i + 1);
    lineSPYs.push(lineSPY);
    let lineEPX = p.windowWidth / 2 + p.windowWidth / 4;
    lineEPXs.push(lineEPX);
    let lineEPY = (p.windowHeight / 10) * (i + 1);
    lineEPYs.push(lineEPY);
    muteKnobs[i] = 150;
  }

  var recordedWidth = p.windowWidth;
  var recordedHeight = p.windowHeight;

  var increment = ((((p.windowWidth / 4) * 3) - (p.windowWidth / 4)) / 100);
  var cellWidth = p.windowWidth / 4;
  var cellHeight = p.windowHeight / 4;
  var exit;
  var exitITCX = (cellWidth * 3) + ((cellWidth - 100) / 2);
  var exitITCY = (cellHeight * 3) + ((cellHeight - 42) / 2);

  p.preload = function preload() {
    exit = p.loadImage("exit.png");
  }

  p.setup = function () {
    p.createCanvas(p.windowWidth, p.windowHeight);
    p.cursor(p.ARROW);
    p.background(200);
    p.image(exit, exitITCX, exitITCY);

  };



  p.draw = function draw() {
    p.background(200);
    p.image(exit, exitITCX, exitITCY);

    for (var i = 0; i < 8; i++) {
      p.line(lineSPXs[i], lineSPYs[i], lineEPXs[i], lineEPYs[i]);
      p.fill(knobColor);
      p.ellipse(sPXs[i], sPYs[i], kD, kD);
      p.fill(muteKnobs[i]);
      p.ellipse((p.windowWidth / 2 - p.windowWidth / 4) - p.windowWidth / 10, sPYs[i], kD - 10, kD - 10);
    }

    if (recordedWidth !== p.windowWidth || recordedHeight !== p.windowHeight) {
      increment = ((((p.windowWidth / 4) * 3) - (p.windowWidth / 4)) / 100);
      for (var j = 0; j < 8; j++) {
        sPXs[j] = p.windowWidth / 2 - p.windowWidth / 4;
        sPYs[j] = (p.windowHeight / 10) * (j + 1);
        lineSPXs[j] = p.windowWidth / 2 - p.windowWidth / 4;
        lineSPYs[j] = (p.windowHeight / 10) * (j + 1);
        lineEPXs[j] = p.windowWidth / 2 + p.windowWidth / 4;
        lineEPYs[j] = (p.windowHeight / 10) * (j + 1);
        muteKnobs[j] = 150;
        p.line(lineSPXs[j], lineSPYs[j], lineEPXs[j], lineEPYs[j]);
        p.fill(knobColor);
        p.ellipse(sPXs[j], sPYs[j], kD, kD);
        p.fill(muteKnobs[j]);
        p.ellipse((p.windowWidth / 2 - p.windowWidth / 4) - p.windowWidth / 10, sPYs[j], kD - 10, kD - 10);
        players[j].volume.value = ((sPXs[j] - lineSPXs[j]) / increment) - 60;
        cellWidth = p.windowWidth / 4;
        cellHeight = p.windowHeight / 4;
        exitITCX = (cellWidth * 3) + ((cellWidth - 100) / 2);
        exitITCY = (cellHeight * 3) + ((cellHeight - 42) / 2);
      }
      recordedWidth = p.windowWidth;
      recordedHeight = p.windowHeight;
    }
    if (p.mouseX > exitITCX && p.mouseX < exitITCX + 100 && p.mouseY > exitITCY && p.mouseY < exitITCY + 42) {
      p.cursor(p.HAND);
    }
  };

  p.windowResized = function windowResized() {
    p.resizeCanvas(p.windowWidth, p.windowHeight);
  };

  p.mouseDragged = function mouseDragged() {
    for (var i = 0; i < 8; i++) {
      if (
        p.mouseX > (sPXs[i] - (kD - 5)) &&
        p.mouseX < (sPXs[i] + (kD - 5)) &&
        p.mouseY > (sPYs[i] - (kD - 5)) &&
        p.mouseY < (sPYs[i] + (kD - 5))
      ) {
        p.background(200);
        sPXs[i] = p.mouseX;
        players[i].volume.value = ((sPXs[i] - lineSPXs[i]) / increment) - 60;
        muteKnobs[i] = 150;
        if (p.mouseX < (p.windowWidth / 2 - p.windowWidth / 4)) {
          sPXs[i] = p.windowWidth / 2 - p.windowWidth / 4;
        }
        if (p.mouseX > (p.windowWidth / 2 + p.windowWidth / 4)) {
          sPXs[i] = p.windowWidth / 2 + p.windowWidth / 4;
        }
      }
    }
  }

  p.mousePressed = function mousePressed() {
    //Mutes
    for (var i = 0; i < 8; i++) {
      if (
        p.mouseX > (((p.windowWidth / 2 - p.windowWidth / 4) - p.windowWidth / 10) - (kD - 20)) &&
        p.mouseX < (((p.windowWidth / 2 - p.windowWidth / 4) - p.windowWidth / 10) + (kD - 20)) &&
        p.mouseY > (sPYs[i] - (kD - 20)) &&
        p.mouseY < (sPYs[i] + (kD - 20))
      ) {
        if (muteKnobs[i] === 150) {
          muteKnobs[i] = "red";
          players[i].mute = true;
        } else {
          muteKnobs[i] = 150;
          players[i].mute = false;
        }
      }
    }
    if (p.mouseX > exitITCX && p.mouseX < exitITCX + 100 && p.mouseY > exitITCY && p.mouseY < exitITCY + 42) {
      window.location = "../";
    }
  }

  p.touchStarted = function touchStarted() {
    for (var i = 0; i < 8; i++) {
      if (
        p.mouseX > (((p.windowWidth / 2 - p.windowWidth / 4) - p.windowWidth / 10) - (kD - 20)) &&
        p.mouseX < (((p.windowWidth / 2 - p.windowWidth / 4) - p.windowWidth / 10) + (kD - 20)) &&
        p.mouseY > (sPYs[i] - (kD - 20)) &&
        p.mouseY < (sPYs[i] + (kD - 20))
      ) {
        if (muteKnobs[i] === 150) {
          muteKnobs[i] = "red";
          players[i].mute = true;
        } else {
          muteKnobs[i] = 150;
          players[i].mute = false;
        }
      }
    }

    if (p.mouseX > exitITCX && p.mouseX < exitITCX + 100 && p.mouseY > exitITCY && p.mouseY < exitITCY + 42) {
      window.location = "../";
    }
  }
}

export default Mixer;


// WEBPACK FOOTER //
// ./src/Mixer.js